import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { ThemeProvider, alpha, createTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import Loader from '../../../components/common/Loader';
import { showModal, hideModal } from '../../../actions/modal';
import Modal from '../../../components/common/Modal';
import { editProfileData, cancelUpdateMobile } from '../../actions/personalInfo';
import { accountCheck } from '../../../refresh/pages/Authentication/actions';
import { getFieldsFromDateAsFormat } from '../../../utils/dateFormatter';
import UpdateMobileNumPopup from './UpdateMobileNumPopup';
import UpdateEmailIdPopup from './UpdateEmailIdPopup';
import UpdateEmailIdPopupNewFlow from './UpdateEmailIdPopupNewFlow';
import UpdatePasswordPopup from './UpdatePasswordPopup.js';
import UpdateEmailIdKioskPopup from './UpdateEmailIdKioskPopup';
import { validateMobile, validateUsername, validatePassword } from '../../../utils/inputValidator';
import ErrorMessage from '../../../components/common/ErrorMessage';
import { readCookie } from '../../../components/common/Cookie';
import { setErrorObject } from '../../../actions/shared/HTTPError';
import {
  getUaas,
  getAvailableDomainsFlag,
  getFraudReductionForEmployeeCouponsFlag,
  getFraudReductionForEmpCouponsLabels,
  getEnableRestorePhoneNumber,
  getRemovalLoginPasswordJson
} from '../../../refresh/selectors/featureFlagsSelector';
import Constants from './PersonalInfoFormConstants';
import { checkMyJioRedirection } from '../../../refresh/utils/myJioUtils';
import { getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import EmailVerify from '../../../refresh/atoms/EmailVerify';
import { isRilDomain } from '../../../utils/common';
import { gtmEventPush, gtmEventPushAccountInteraction } from '../../../modules/ga/GTMdatalayer';
import { getProperty } from '../../../modules/ajio-util/properties';
import Image from '../../../refresh/atoms/ImageView';
import Dialog from '../../../refresh/molecules/Dialog';
import styles2 from '../../../refresh/pages/Account/Account.pcss';
import Button from '../../../refresh/atoms/button';
import Text from '../../../refresh/atoms/Text';
import DatePicker from '../../../refresh/atoms/DatePicker';


// FOR DATEPICKER
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

const cx = classNames.bind(styles2);

// const styles = {
//   floatingLabelFocusStyle: {
//     fontSize: '12px',
//     left: '1px',
//     color: '#6D6D6D'
//   },
//   inputStyle: {
//     fontSize: '14px',
//     height: '60px',
//     paddingBottom: '8px',
//     color: '#6D6D6D'
//   },
//   textAreaStyle: {
//     fontSize: '14px',
//     paddingBottom: '8px',
//     color: '#6D6D6D'
//   },
//   floatingLabelShrinkStyle: {
//     lineHeight: '2px',
//     left: '1px',
//     color: '#6D6D6D'
//   },
//   datePickerTextFieldStyle: {
//     lineHeight: '16px',
//     left: '1px',
//     fontSize: '14px',
//     color: '#6D6D6D'
//   }
// };

const theme = createTheme({
  palette: {
    primary: {
      main: '#866528',
    },
  },
  components: {
    MuiDatePicker: {
      styleOverrides: {
        root: {
          color: '#866528',
        },
        toolbar: {
          backgroundColor: '#866528',
        },
      },
    },
  },
});

const textFieldStyles = {
  marginTop: '16px',

  '.MuiFormLabel-root': {
    fontSize: '14px'
  },

  '.MuiInputBase-root:hover::before': {
    borderBottom: `1px solid ${alpha('#000000', '0.42')} !important`
  },

  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#6d6d6d', 
    color:            '#6d6d6d',     
    
    '&::placeholder': {
      color:   '#6d6d6d',
      opacity: 1,
    },
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: '#6d6d6d',
  },

  input: {
    fontSize: '14px'
  }
};

const datePickerStyles = {
  display: 'block',
  marginTop: '36px',

  '.MuiFormLabel-root': {
    left: '-12px',
    fontSize: '14px',
    top: '-10px'
  },

  '.MuiInputBase-root': {
    display: 'block',

    input: {
      backgroundColor: 'unset !important',
      border: 'unset !important',
      fontSize: '14px',
      padding: '0 0 4px 0'
    },

    fieldset: {
      border: 'none',
      borderBottom: `1px solid ${alpha('#000000', '0.23')}`
    },

    '&:hover': {
      fieldset: {
        borderBottom: `1px solid ${alpha('#000000', '0.23')} !important`
      }
    }
  }
}

// const theme = createTheme({
//   palette: {
//     primary1Color: '#866528'
//   },
//   datePicker: {
//     selectColor: '#866528',
//     headerColor: '#866528'
//   }
// });

// const theme = createTheme({
//   palette: {
//     primary1Color: '#866528'
//   },
//   datePicker: {
//     selectColor: '#866528',
//     headerColor: '#866528'
//   }
// });

class PersonalInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    this.state = {
      ...this.state,
      renderModal: false,
      errFirstName: '',
      errLastName: '',
      errConfirmPwd: '',
      errNewPwd: '',
      newPwd: '',
      dateOfBirth: '',
      errorPresent: false,
      isFraudReductionForEmpApplicable: false,
      showCancelRequestDialog: false,
      restoreMobileNumberFlowUpdatedHours: '24 hours',
      showCalendar: false,
      restoreMessage: '', 
      errorPresent: false
    };
    this._setModal = this.setModal.bind(this);
    this.updateProfileSubmit = this.updateProfileSubmit.bind(this);
    this.cancelMobileUpdate = this.cancelMobileUpdate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setShowCalendar = this.setShowCalendar.bind(this);
    this.datePickerRef = React.createRef();
    this.dobFieldRef = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let {
      profile: { dateOfBirth = '', emailVerified = false, displayUid: emailId = '', uid = '' } = {},
      isUaas,
      fraudReductionForEmployeeCouponsFlag,
      source = '',
      availableDomains
    } = this.props;
    const rilDomain = emailId && isRilDomain(availableDomains, emailId);
    const isFraudReductionForEmpApplicable =
      fraudReductionForEmployeeCouponsFlag && isUaas && rilDomain && !emailVerified;
    this.setState({
      dateOfBirth,
      isFraudReductionForEmpApplicable
    });
    if (source === 'desktop' && isFraudReductionForEmpApplicable) {
      gtmEventPush({
        event: 'widget_interaction',
        event_category: 'widget_interaction',
        event_action: 'verify email impression',
        screen_name: 'my account screen'
      });
    }
    this.props.accountCheck({ emailId: uid }, res => {
      if (res?.updateNumberRequestWindow) {
        this.setState({ restoreMobileNumberFlowUpdatedHours: res?.updateNumberRequestWindow });
      }
    });
  }

  componentWillReceiveProps(newProps) {
    if (this.props.profile?.emailVerified !== newProps.profile?.emailVerified) {
      let {
        profile: { displayUid: emailId = '' } = {},
        isUaas,
        fraudReductionForEmployeeCouponsFlag,
        availableDomains
      } = this.props;
      const rilDomain = emailId && isRilDomain(availableDomains, emailId);
      const isFraudReductionForEmpApplicable =
        fraudReductionForEmployeeCouponsFlag &&
        isUaas &&
        rilDomain &&
        !newProps.profile?.emailVerified;
      this.setState({
        isFraudReductionForEmpApplicable
      });
    }
  }

  handleChange(date) {
    this.setState({
      dateOfBirth: date
    });
  }

  handleBlurChange() {
    if (this.state.newPwd === this.state.confirmPwd) {
      this.setState({
        errConfirmPwd: ''
      });
    } else {
      this.setState({
        errConfirmPwd: 'New Password and Confirm Password do not match.'
      });
    }
  }

  handleInputChange(newPartialInput) {
    let inputObjKey = Object.keys(newPartialInput)[0];
    let inputObjVal = Object.values(newPartialInput)[0];
    if (inputObjKey == 'firstName') {
      if (validateUsername(inputObjVal)) {
        this.setState({
          errFirstName: ''
        });
      } else {
        this.setState({
          errFirstName: 'Accepts only alphabets & spaces between words.'
        });
      }
    } else if (inputObjKey == 'lastName') {
      if (validateUsername(inputObjVal)) {
        this.setState({
          errLastName: ''
        });
      } else {
        this.setState({
          errLastName: 'Accepts only alphabets & spaces between words.'
        });
      }
    } else if (inputObjKey == 'newPassword') {
      if (validatePassword(inputObjVal) || inputObjVal === '') {
        this.setState({
          errNewPwd: ''
        });
      } else {
        this.setState({
          errNewPwd:
            'Password should have a minimum of 8 characters with atleast one number, one alphabet and one special character.'
        });
      }
    } else if (inputObjKey == 'confirmPassword') {
      if (this.state.newPwd === inputObjVal) {
        this.setState({
          errConfirmPwd: ''
        });
      } else {
        this.setState({
          errConfirmPwd: 'New Password and Confirm Password do not match.'
        });
      }
    }
    this.setState(state => ({
      ...state,
      profile: {
        ...state.profile,
        ...newPartialInput
      }
    }));
  }

  handleResetButton(event, initialProfileData) {
    event.preventDefault();
    this.setState(state => ({
      ...state,
      profile: initialProfileData,
      dateOfBirth: initialProfileData?.dateOfBirth,
      errFirstName: '',
      errLastName: '',
      errConfirmPwd: '',
      errNewPwd: '',
      newPwd: ''
    }));
  }

  updateProfileSubmit(event) {
    event.preventDefault();
    if(this.state.errFirstName || this.state.errLastName) {
      this.setState({errorPresent: true})
    } else if(!(this.state.errFirstName || this.state.errLastName)) {
      this.setState({errorPresent: false})
    }
    const { isUaas = false } = this.props;
    const formData = document.getElementById('updateProfileForm')
      ? document.getElementById('updateProfileForm').elements
      : [];
    let profileFormData = {};
    let { source = '' } = this.props;
    let dob = moment(this.state.dateOfBirth).format(Constants?.dobFormat);
    if (dob) {
      profileFormData.dateOfBirth = dob.trim();
    }
    for (let idx = 0, len = formData.length; idx < len; idx++) {
      let { name = '', value = '', type = '' } = formData[idx] || {};
      if (value && ['button', 'radio', 'submit'].indexOf(type) == -1) {
        profileFormData[name] = value.trim();
      } else if (value && type == 'radio' && formData[idx].checked) {
        profileFormData[name] = value.trim();
      }
    }

    const errorForm = document.getElementsByClassName('prof-info-error-msg')
      ? document.getElementsByClassName('prof-info-error-msg')
      : [];

    if (errorForm.length) {
      this.setState({ errorPresent: true });
    }
    if (!this.state.profile.firstName || !this.state.profile.lastName) {
      let newState = { errorPresent: true };
      if (!this.state.profile.firstName) {
        newState.errFirstName = 'Missing first name';
      } else if (!this.state.profile.lastName) {
        newState.errLastName = 'Missing last name';
      }
      this.setState(newState);
    } else if (!errorForm.length) {
      this.setState({ errorPresent: false });
      this.props.editProfileData(profileFormData, source);
    }
  }

  setModal(modal) {
    this.setState({ renderModal: true, modal }, () => {
      this.props.showModal(modal.name);
    });
  }

  isMobile() {
    let mobileDevice = false;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      mobileDevice = true;
    }
    return mobileDevice;
  }

  // setShowCalendar = (calendarView) => {
  //   this.setState({
  //     showCalendar: calendarView
  //   })
  // }

  setShowCalendar = (calendarView) => {
    this.setState({ showCalendar: calendarView }, () => {
      if (calendarView) {
        this.datePickerRef?.current?.focus();
      } else {
        this.dobFieldRef?.current?.focus();
      }
    });
  };

  formatDate = (inputDate) => {
    if (!inputDate) return '';
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return ''; 
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  cancelMobileUpdate() {
    function isMobile() {
      let mobileDevice = false;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ) {
        mobileDevice = true;
      }
      return mobileDevice;
    }
    gtmEventPushAccountInteraction('my account screen', 'cancel request', 'yes');
    this.props.cancelUpdateMobile(
      {
        oldMobileNumber: this.props.profile.mobileNumber
      },
      res => {
        if (res.success) {
          localStorage.setItem('cancelUpdateMsg', 'Request cancelled');
          this.props.hideModal('cancel-update-mobile');
          window.location.href = isMobile() ? '/my-account/' : '/my-account/orders';
        }
      }
    );
  }

  renderPasswordPopup(kioskCustomer) {
    const PopupComponent = kioskCustomer ? UpdateEmailIdKioskPopup : UpdateEmailIdPopup;
    return (
      <span
        className="change-mobile-num"
        role="button"
        tabIndex={0}
        onClick={() => {
          gtmEventPushAccountInteraction('update email address', 'change email address');
          this.setModal({
            name: 'update-email',
            classes: 'update-email-modal',
            content: <PopupComponent modalName="update-email" />
          });
          ga('send', {
            eventCategory: 'buttonTap',
            eventAction: 'Change Personal Info',
            eventLabel: 'Change Email Address'
          });
        }}
        aria-label="Change Email Address"
      >
        <strong>CHANGE</strong>
      </span>
    );
  }

  isFormPristine() {
  const { profile: initial = {} } = this.props;
  const { profile: current = {}, dateOfBirth } = this.state;

  return (
    initial.firstName === current.firstName &&
    initial.lastName === current.lastName &&
    initial.mobileNumber === current.mobileNumber &&
    initial.genderType === current.genderType &&
    initial.screenName === current.screenName &&
    initial.identity === current.identity &&
    initial.dateOfBirth === dateOfBirth
  );
  }

  render() {
    // taking initial values for Change Mobile form
    const {
      profile: initialProfData = {},
      personalInfoDetail = '',
      getAjioMassEmailIdOptional
    } = this.props;

    const { profile = {}, dateOfBirth: dobState = '', showCalendar = false } = this.state;

    let {
      identity = '',
      firstName = '',
      lastName = '',
      mobileNumber = '',
      dateOfBirth = '',
      screenName = '',
      genderType = '',
      kioskCustomer,
      displayEmail,
      displayUid: emailId = '',
      updateNumberRequestWindow = '24 Hr.',
      updateRequestPending = false
    } = profile;

    // let { httpError : { error : { message: msg = ''} = {} } = {} } = this.props;

    let currentDate = new Date();
    let uid = decodeURIComponent(readCookie('U'));
    const {
      modal: { name = '', classes = '', content = '' } = {},
      isFraudReductionForEmpApplicable
    } = this.state;
    const {
      isUaas = false,
      source = '',
      availableDomains,
      fraudReductionForEmpCouponsLabels,
      enableRestorePhoneNumber = false,
      profile_change_new_number_note = '',
      myaccount_request_phone_update_message = ''
    } = this.props;
    const profileChangeNewNumberNote = profile_change_new_number_note.replace(
      '%s',
      this.state.restoreMobileNumberFlowUpdatedHours
    );
    const myaccountRequestPhoneUpdateMessage = myaccount_request_phone_update_message.replace(
      '%s',
      this.state.restoreMobileNumberFlowUpdatedHours
    );
    return (
      <div className="personal-info-block">
        {!personalInfoDetail && <h1 id="personal-info-header" className="heading"> Personal Information</h1>}
        {!personalInfoDetail && (
          <p className="content">
            Hey there! Fill in your details for a personalized AJIO shopping experience.
          </p>
        )}
        <Loader name="quickview-loader" />
        <ThemeProvider theme={theme}>
          {this.state.errorPresent && (
            <div
              id="profile-form-error-summary"
              role="alert"
              aria-live="assertive"
              className="sr-only"
            >
              Errors found on the page
            </div>
          )}
          <form
              className="update-profile-form"
              id="updateProfileForm"
              onSubmit={this.updateProfileSubmit}
            >
              <div className="">
                <TextField
                  id='update-first-name'
                  value={firstName}
                  onChange={e => this.handleInputChange({ firstName: e.target.value })}
                  name="firstName"
                  size="medium"
                  maxLength="64"
                  label="First Name*"
                  fullWidth
                  // style={styles.inputStyle}
                  variant="standard"
                  sx={textFieldStyles}
                  error={!!this.state.errFirstName}
                  inputProps={{
                    'aria-describedby': this.state.errFirstName ? 'first-name-error-msg' : undefined,
                  }}
                />
                {this.state.errFirstName && (
                  <span id='first-name-error-msg' className="prof-info-error-msg">{this.state.errFirstName}</span>
                )}
              </div>
              <div className="">
                <TextField
                  value={lastName}
                  onChange={e => this.handleInputChange({ lastName: e.target.value })}
                  name="lastName"
                  size="32"
                  maxLength="64"
                  label="Last Name*"
                  fullWidth
                  error={!!this.state.errLastName}
                  inputProps={{
                    'aria-describedby': this.state.errLastName ? 'last-name-error-msg' : undefined,
                  }}
                  FormHelperTextProps={{
                    id: "last-name-error-msg"
                  }}
                  // style={styles.inputStyle}
                  // floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                  // floatingLabelStyle={styles.floatingLabelShrinkStyle}
                  variant="standard"
                  sx={textFieldStyles}
                />
                {this.state.errLastName && (
                  <span id='last-name-error-msg' className="prof-info-error-msg">{this.state.errLastName}</span>
                )}
              </div>
              <div className="">
                <TextField
                  value={screenName}
                  onChange={e => this.handleInputChange({ screenName: e.target.value })}
                  name="screenName"
                  size="32"
                  maxLength="64"
                  label="Screen Name"
                  fullWidth
                  // style={styles.inputStyle}
                  // floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                  // floatingLabelStyle={styles.floatingLabelShrinkStyle}
                  autoComplete="off"
                  variant="standard"
                  sx={textFieldStyles}
                />
              </div>
              <div className="">
                {getAjioMassEmailIdOptional ? (
                  getFeatureVariant('email-is-optional') === '0' ? (
                    <TextField
                      disabled
                      value={!displayEmail ? '' : emailId}
                      type="email"
                      label="Email Address"
                      // style={styles.inputStyle}
                      fullWidth
                      // floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      // floatingLabelStyle={styles.floatingLabelShrinkStyle}
                      variant="standard"
                      sx={textFieldStyles}
                    />
                  ) : (
                    <TextField
                      disabled
                      value={!displayEmail ? '' : emailId}
                      type="email"
                      label="Email Address"
                      // style={styles.inputStyle}
                      fullWidth
                      // floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      // floatingLabelStyle={styles.floatingLabelShrinkStyle}
                      variant="standard"
                      sx={textFieldStyles}
                    />
                  )
                ) : (
                  <TextField
                    disabled
                    value={!displayEmail ? '' : emailId}
                    type="email"
                    label="Email Address*"
                    // style={styles.inputStyle}
                    fullWidth
                    // floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                    // floatingLabelStyle={styles.floatingLabelShrinkStyle}
                    variant="standard"
                    sx={textFieldStyles}
                  />
                )}
                {this.renderPasswordPopup(kioskCustomer, enableRestorePhoneNumber)}
                {source === 'desktop' && isFraudReductionForEmpApplicable && (
                  <span>
                    <EmailVerify
                      sourceType="VERIFY"
                      ctaLabel={fraudReductionForEmpCouponsLabels?.verifyEmail}
                    />
                  </span>
                )}
              </div>

              <div>
                <TextField
                  value={this.formatDate(dobState)}
                  onClick={() => this.setShowCalendar(true)}
                  name="dob"
                  size="32"
                  maxLength="64"
                  label={<div role="button">Date of Birth</div>}
                  fullWidth
                  // style={styles.inputStyle}
                  // floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                  // floatingLabelStyle={styles.floatingLabelShrinkStyle}
                  autoComplete="off"
                  variant="standard"
                  sx={textFieldStyles}
                  inputRef={this.dobFieldRef}
                />
              </div>

              {showCalendar && 
                <div className={cx('modal')} role="dialog" aria-modal="true" aria-label="Date Picker" tabIndex={-1} ref={this.datePickerRef}>
                  <div
                    className={cx('modal-background')}
                    onClick={() => setShowCalendar(!showCalendar)}
                  >
                  <div className={cx('modal-content')} onClick={e => e.stopPropagation()}>
                    <div className={cx('date-picker')}>
                      <DatePicker 
                        onDateSelect={this.handleChange} 
                        setShowCalendar={this.setShowCalendar} 
                        skipUpdateOncancel
                        preventDefaultPropagation
                        isEditProfile
                      />
                    </div>
                  </div>
                  </div>
                </div>
              }

              <div className="">
                <p className="input-box radioButton">
                  <span className="radioButton-header">Gender</span>
                  <input
                    type="radio"
                    className="radioButton"
                    name={isUaas ? 'genderType' : 'gender'}
                    value="Female"
                    checked={!!(isUaas ? genderType === 'FEMALE' : genderType === 'FEMALE')}
                    onChange={e =>
                      this.handleInputChange({ genderType: isUaas ? 'FEMALE' : 'FEMALE' })
                    }
                    aria-describedby='radio-text-female'
                  />
                  <label id='radio-text-female' aria-hidden="true" className="radio-text">Female</label>
                  <input
                    type="radio"
                    className="radioButton"
                    name={isUaas ? 'genderType' : 'gender'}
                    value="Male"
                    checked={!!(isUaas ? genderType === 'MALE' : genderType === 'MALE')}
                    onChange={e => this.handleInputChange({ genderType: isUaas ? 'MALE' : 'MALE' })}
                    aria-describedby='radio-text-male'
                  />
                  <label id='radio-text-male' aria-hidden="true" className="radio-text">Male</label>
                </p>
              </div>

              <TextField
                value={mobileNumber}
                disabled
                readOnly
                type="tel"
                label="Telephone +91*"
                fullWidth
                // style={styles.inputStyle}
                // floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                // floatingLabelStyle={styles.floatingLabelShrinkStyle}
                variant="standard"
                sx={textFieldStyles}
              />
              <span
                className={`change-mobile-num  ${updateRequestPending ? 'disabled-newFlow' : ''}`}
                role="button"
                tabIndex={0}
                onClick={() => {
                  if (updateRequestPending) return;

                  gtmEventPushAccountInteraction('update mobile number', 'change mobile number');
                  this.setModal({
                    name: 'update-mobile',
                    classes: 'update-mobile-modal',
                    content: (
                      <UpdateMobileNumPopup
                        modalName="update-mobile"
                        initialProfData={initialProfData}
                        isUaas={isUaas}
                        enableRestorePhoneNumber={enableRestorePhoneNumber}
                        profileChangeNewNumberNote={profileChangeNewNumberNote}
                      />
                    )
                  });
                }}
                aria-label="Change Telephone Number"
              >
                <strong>CHANGE</strong>
              </span>

              {updateRequestPending ? (
                <div className="phone-update-progress-alert">
                  <div className="new-phone-number-request-section">
                    <div className="alert-icon">
                      <Image
                        src={`${getProperty(
                          'imageBaseUrl'
                        )}/static/img/new-mobile-number-request-alert-icon.svg`}
                        alt="Alert icon"
                      />
                    </div>
                    <div className="content-details">
                      <div className="description">{myaccountRequestPhoneUpdateMessage || ''}</div>
                      <div
                        className="cancel-request-btn"
                        onClick={() => {
                          gtmEventPushAccountInteraction(
                            'my account screen',
                            'new mobile number',
                            'cancel request'
                          );
                          if (this.isMobile()) {
                            this.setState({
                              showCancelRequestDialog: true
                            });
                            return;
                          }
                          this.setModal({
                            name: 'cancel-update-mobile',
                            classes: 'cancel-update-mobile-modal',
                            content: (
                              <div className="cancel-update-mobile_div">
                                <p className="cancel-btn-info">
                                  Are you sure that you want to cancel the Phone number update
                                  request?
                                </p>
                                <div className="card-delete-button">
                                  <div
                                    onClick={() => {
                                      this.props.hideModal('cancel-update-mobile');
                                      gtmEventPushAccountInteraction(
                                        'my account screen',
                                        'cancel request',
                                        'no'
                                      );
                                    }}
                                  >
                                    No
                                  </div>
                                  <div
                                    onClick={() => this.cancelMobileUpdate()}
                                    className="delete-btn"
                                  >
                                    Yes
                                  </div>
                                </div>
                              </div>
                            )
                          });
                        }}
                      >
                        Cancel Request
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {enableRestorePhoneNumber && this.state.showCancelRequestDialog && (
                <Dialog
                  showDialog={this.state.showCancelRequestDialog}
                  type="drawer"
                  closeIcon={false}
                >
                  <main className={cx('dialog-body')}>
                    <div className={cx('text-container')}>
                      <Text variant="T4" color="Nero">
                        Are you sure that you want to cancel the Phone number update request?
                      </Text>
                    </div>
                    <div className={cx('dialog-cta-container')}>
                      <div className={cx('left-cta')}>
                        <Button
                          id="no"
                          ariaLabel="No"
                          variant="secondary"
                          disabled={false}
                          size="lg"
                          radius={8}
                          btnLabel="No"
                          onClick={() => {
                            gtmEventPushAccountInteraction(
                              'my account screen',
                              'cancel request',
                              'no'
                            );
                            this.setState({
                              showCancelRequestDialog: false
                            });
                          }}
                        />
                      </div>
                      <div className={cx('cta-right')}>
                        <Button
                          id="cancel"
                          ariaLabel="Yes"
                          variant="primary"
                          disabled={false}
                          size="lg"
                          radius={8}
                          btnLabel="Yes"
                          onClick={() => {
                            this.cancelMobileUpdate();
                            this.setState({
                              showCancelRequestDialog: false
                            });
                          }}
                        />
                      </div>
                    </div>
                  </main>
                </Dialog>
              )}

              <div className="prof-form-button-section">
                <button
                  onClick={e => {
                  if (this.isFormPristine()) {
                    e.preventDefault();
                    return;
                  }
                  this.handleResetButton(e, initialProfData);
                }}
                  type="button"
                  className="button"
                aria-disabled={this.isFormPristine()}
                aria-label={
                  this.isFormPristine()
                    ? 'Restore, disabled. No changes to restore.'
                    : 'Restore, Press to revert changes.'
                }
                >
                  RESTORE
                </button>
                <input type="submit" className="button-update" value="UPDATE" />
              {this.state.restoreMessage && (
                <div
                  className="sr-only"
                  role="alert"
                  aria-live="assertive"
                >
                  {this.state.restoreMessage}
                </div>
              )}
              </div>
            </form>
        </ThemeProvider>

        {this.state.renderModal ? (
          <Modal
            name={name}
            className={classes}
            onClose={() => {
              this.setState({ renderModal: false, modal: {} });
              this.props.clearErrorObj();
            }}
          >
            {content}
          </Modal>
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    editProfileData: (formData, source) => {
      dispatch(editProfileData(formData, source));
    },
    cancelUpdateMobile: (formData, callback) => {
      dispatch(cancelUpdateMobile(formData, callback));
    },
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    clearErrorObj: () => {
      dispatch(setErrorObject({}));
    },
    accountCheck: (...args) => {
      dispatch(accountCheck(...args));
    }
  };
};

const mapStatetoProps = state => {
  const isMyJioRedirection = checkMyJioRedirection();
  const removalLoginPasswordJson = getRemovalLoginPasswordJson(state?.flags);
  const profile_change_new_number_note =
    removalLoginPasswordJson?.profile_change_new_number_note || '';
  const myaccount_request_phone_update_message =
    removalLoginPasswordJson?.myaccount_request_phone_update_message || '';
  return {
    isUaas: getUaas(state) || isMyJioRedirection,
    fraudReductionForEmployeeCouponsFlag: getFraudReductionForEmployeeCouponsFlag(state),
    fraudReductionForEmpCouponsLabels: getFraudReductionForEmpCouponsLabels(state),
    availableDomains: getAvailableDomainsFlag(state),
    enableRestorePhoneNumber: getEnableRestorePhoneNumber(state?.flags),
    profile_change_new_number_note: profile_change_new_number_note,
    myaccount_request_phone_update_message
  };
};

export default PersonalInfoForm = connect(mapStatetoProps, mapDispatchToProps)(PersonalInfoForm);